import "slick-carousel";
import { Screen } from "./helper";

Cm.slick = {
    init: function() {
        $('[data-plugin="slick"]').each( function() {
            var ds = this.dataset;
            var $el = $(this);
            var loaderId = '#'+$el.attr('target-loader');
            var settings = $.extend(Cm.o('slick.settings'), {
                slidesToShow: Cm.toInt( ds.slickSlidesToShow || Cm.o('slick.settings.slidesToShow') ),
                slidesToScroll: Cm.toInt( ds.slickSlidesToScroll || Cm.o('slick.settings.slidesToScroll') ),
                nextArrow: ds.slickArrows || Cm.o('slick.settings.nextArrow'),
                dots: Cm.isTrue( ds.slickDots || Cm.o('slick.settings.dots') ),
                variableWidth: Cm.isTrue( ds.slickVariableWidth || Cm.o('slick.settings.variableWidth') ),
                responsive: ds.slickResponsive ? JSON.parse(ds.slickResponsive) : Cm.o('slick.settings.responsive'),
                autoplay: Cm.isTrue( ds.slickAutoplay || Cm.o('slick.settings.autoplay') ),
                speed: ds.slickSpeed || Cm.o('slick.settings.speed'),
                autoplaySpeed: ds.slickAutoplaySpeed || Cm.o('slick.settings.autoplaySpeed'),
            });

            $(this).on('init', function(event, slick) {
                $(loaderId).remove();
                $el.removeClass('invisible-layer');
                Cm.slick.afterInit(event, slick);
            }).slick(settings);
        });            
    },
    afterInit: function(event, slick) {
        this.screen(event, slick);

        var $slider = $(event.currentTarget);
        $slider.find('.slider__arrow__left').off('click').on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            $slider.slick('slickPrev');
        });
    },
    screen: function(event, slick) {
        var $slider = $(event.currentTarget);

        function adjustScreen() {
            if($slider.hasClass('home-slider')) {
                // set slick dots position
                var height = $($slider.find('.slick-track').children()[0]).find('img').outerHeight();
                $slider.find('.slick-dots').attr('style', 'top: '+height+'px;');

                // // set width
                setTimeout(function() {
                    $slider.find('.slick-slide').each( function() {
                        const imgWidth = $(this).find('img').width();
                        $(this).find('.slider__subtitle___1q3Cz,.slider__title___1NMVp,.slider__link___1IyWB').css({
                            maxWidth: imgWidth + 'px'
                        });
                        // $(this).attr('style', 'width: ' + ( $(this).find('img').outerWidth() + 20 ) + 'px;');
                    });
                }, 1000);
            } else {
                var $firstSlide = $slider.find('.slick-slide').eq(0);
                $slider.find('.slick-slide').each( function() {
                    var sw = Screen.width();
                    if( Screen.width() < 485) {
                        $(this).css('width', (sw - 70) + 'px')
                    }
                });
                
                // adjust arrow height on simple sliders
                setTimeout( function() {
                    $slider.find('.slider__arrow__left,.slider__arrow__right').css('height', $firstSlide.find('img').innerHeight()+'px');
                }, 200);
            }

            // !important: set position on resize
            $slider.slick('setPosition');
        }

        $(window).resize(adjustScreen);

        setTimeout(adjustScreen, 100);
    },
};